import { get, deleteItem, post, put } from '@/utils/request';

/**
 * 谷歌登录
 * @param {object} params
 * @param {string} params.googleIdToken token
 * @returns
 */
export const googleLogin = (params) => {
  const formData = new FormData();

  for (const key in params) {
    if (params[key] !== 'undefined' && typeof params[key] !== 'undefined') {
      formData.append(key, params[key]);
    }
  }

  return post('/v1/aichat/passport/googleLogin', formData, { requestType: 'form' });
};

/**
 * Facebook登录
 * @param {object} params
 * @param {string} params.shortToken token
 * @param {string} params.facebookUserId token
 * @param {string} params.username token
 * @returns
 */
export const facebookLogin = (params) => {
  const formData = new FormData();

  for (const key in params) {
    if (params[key] !== 'undefined' && typeof params[key] !== 'undefined') {
      formData.append(key, params[key]);
    }
  }

  return post('/v1/aichat/passport/facebookLogin', formData, { requestType: 'form' });
};

/**
 * 邮箱登录
 * @param {object} params
 * @param {string} params.email email
 * @param {string} params.password 用户id
 * @returns
 */
export const login = (params) => {
  const formData = new FormData();

  for (const key in params) {
    if (params[key] !== 'undefined' && typeof params[key] !== 'undefined') {
      formData.append(key, params[key]);
    }
  }

  return post('/v1/aichat/passport/login', formData, { requestType: 'form' });
};

/**
 * 邮箱登录注册
 * @param {object} params
 * @param {string} params.email email
 * @param {string} params.password 用户id
 * @returns
 */
export const register = (params) => {
  const formData = new FormData();

  for (const key in params) {
    if (params[key] !== 'undefined' && typeof params[key] !== 'undefined') {
      formData.append(key, params[key]);
    }
  }

  return post('/v1/aichat/passport/register', formData, { requestType: 'form' });
};

/**
 * 用户信息
 * @returns
 */
export const getUserInfo = () => get('/v1/aichat/getUserInfo');

/**
 * 登录绑定
 * @param {object} params
 * @param {string} params.email email
 * @param {string} params.password 用户id
 * @returns
 */
export const loginBind = (params) => {
  const formData = new FormData();

  for (const key in params) {
    if (params[key] !== 'undefined' && typeof params[key] !== 'undefined') {
      formData.append(key, params[key]);
    }
  }

  return post('/v1/aichat/passport/loginBind', formData, { requestType: 'form' });
};
export const delAccount = (params) => {
  return deleteItem('/v1/aichat/logout', { ...params });
};
/**
 * 删除照片任务
 * @param {object} params
 * @param {string} params.aiType 枚举： undress, text2img, dance,dress_Switch,face_swap
 * @param {string} params.taskId 任务id
 * @returns
 */
export const delTaskId = (params) => {
  return put(`/v1/aichat/aigc/indisposed/${params.aiType}/${params.taskId}`, { ...params });
};
/**
 * 删除照片任务
 * @param {object} params
 * @param {string} params.aiType 枚举： undress, text2img, dance,dress_Switch,face_swap
 * @param {string} params.taskIdList 数组传[]表示删除所有，删除部分['1','2']
 * @returns
 */
export const delTaskIdAll = (params) => {
  let item = {};
  item.taskIdList = [];
  return put(`/v1/aichat/aigc/indisposed/${params.aiType}/deleteBatch`, { ...item });
};
